<template>
  <div class="login-divider" role="separator" aria-label="or with email">
    <div class="divider-line" aria-hidden="true"></div>
    <span class="divider-text">or with email</span>
    <div class="divider-line" aria-hidden="true"></div>
  </div>
</template>

<style scoped>
.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 20px 0;
}

.divider-line {
  flex: 1;
  height: 1px;
  background-color: var(--border-subtle);
}

.divider-text {
  font-size: var(--font-size-micro);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

:global(html:not(.theme-light)) .divider-line {
  background-color: var(--border-subtle);
}

:global(html:not(.theme-light)) .divider-text {
  color: var(--text-muted);
}
</style>
